import React, { Component } from 'react'
import ActionCableContainer from 'containers/ActionCableContainer'
import BrowserValidatorContainer from 'containers/BrowserValidatorContainer'
import VisitCheckIn from 'components/VisitCheckIn'
import queryString from 'query-string'
import {withMediaAvailabilityCheck} from 'utils/hocs'

export class VisitCheckInContainer extends Component {

  render() {
    const {
      location: {
        search
      }
    } = this.props

    const webrtcTokenJSONString = queryString.parse(search.substr(1)).webrtc_token
    const webrtcToken = webrtcTokenJSONString ? JSON.parse(webrtcTokenJSONString) : {
      value: queryString.parse(search.substr(1)).twilioToken,
      provider: 'twilio'
    }
    const roomName = queryString.parse(search.substr(1)).twilioRoomId

    return (
      <BrowserValidatorContainer>
        <ActionCableContainer
          userToken={roomName}
          channelName='CheckInChannel'
        />
        <VisitCheckIn
          webrtcToken={webrtcToken}
          roomName={roomName}
        />
      </BrowserValidatorContainer>
    )
  }
}

export default withMediaAvailabilityCheck(VisitCheckInContainer)
